import { CurrentPlatform } from '../../../shared/enums';

export const PLATFORM_DATA_KEY = 'platformData';

export interface IPlatformDataState {
  platform: CurrentPlatform | null;
}

export enum PlatformActions {
  SetCurrentPlatformData = 'SetCurrentPlatformData',
}
